import React from "react";
import Modal from "../../component/Inc/Modal";
function PopInvoice(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="pop_invoice" >
      <h2 className="pop_tit">송장번호 입력</h2>
      <div className="content_container scroll">
        <li className="input_field">
          <input
            type="text"
            className="input lightGray"
            defaultValue={`택배사 명 입력`}
          />
        </li>
        <table className="com_board_list type_row">
					<colgroup>
					<col width="60"/>
					<col width="auto"/>
					</colgroup>
          <tbody>
            <tr>
              <th>1 No.</th>
              <td className="td_left">22</td>
            </tr>
            <tr>
              <th>1 송장번호</th>
              <td>
								<input type="text" className="input" />
							</td>
            </tr>
          </tbody>
        </table>
        <table className="com_board_list type_row">
					<colgroup>
					<col width="60"/>
					<col width="auto"/>
					</colgroup>
          <tbody>
            <tr>
              <th>2 No.</th>
              <td className="td_left">22</td>
            </tr>
            <tr>
              <th>2 송장번호</th>
              <td>
								<input type="text" className="input" />
							</td>
            </tr>
          </tbody>
        </table>
        <table className="com_board_list type_row">
					<colgroup>
					<col width="60"/>
					<col width="auto"/>
					</colgroup>
          <tbody>
            <tr>
              <th>3 No.</th>
              <td className="td_left">22</td>
            </tr>
            <tr>
              <th>3 송장번호</th>
              <td>
								<input type="text" className="input" />
							</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopInvoice;
